// FORM VALIDATION REGEX
export const currencyRegex = /^$|^\d+(\.\d{1,2})?$/;
export const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
